import { Injectable } from '@angular/core';
import { API } from '@core/services/api.base';
import { Observable } from 'rxjs';
import { BusinessInformationEntity } from 'src/app/models/business.model';
import {
  BusinessInformationDto,
  CustomerFormDtoTotal,
  CustomerFormEntity,
} from 'src/app/models/customer-form.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerFormService extends API {
  createCustomerForm(
    data: CustomerFormDtoTotal
  ): Observable<CustomerFormEntity> {
    return this.post<CustomerFormEntity, CustomerFormDtoTotal>(
      'v1/onboarding-form',
      data
    );
  }

  createBusinessInformation(
    data: BusinessInformationDto,
    isSaleEntered: boolean,
    salePhoneNumber: string
  ): Observable<BusinessInformationEntity> {
    const params = `created=${
      isSaleEntered ? 'sale' : 'customer'
    }&phone=${salePhoneNumber}`;
    return this.post<BusinessInformationEntity, BusinessInformationDto>(
      `v1/business-information?${params}`,
      data
    );
  }

  formatPhoneNumberForDatabase(input: string): string {
    const phonePrefix = input.split(' ')[0];
    let digits = input.replace(/\D/g, '');

    if (
      phonePrefix === '(076)' ||
      phonePrefix === '(093)' ||
      phonePrefix === '(097)' ||
      phonePrefix === '(090)' ||
      phonePrefix === '(032)' ||
      phonePrefix === '(098)' ||
      phonePrefix === '(096)'
    ) {
      digits = '84' + digits;
    } else {
      digits = '1' + digits;
    }

    return '+' + digits;
  }

  capitalizeWords(words: string) {
    return words
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  transferZipCodeToLatLong(
    zipCode: string
  ): Observable<{ latitude: number; longitude: number }> {
    return this.get<{ latitude: number; longitude: number }>(
      `v1/zip-code/${zipCode}`
    );
  }
}
